var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRuler = function SvgRuler(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34447 12.0002L8.46579 14.1216M9.17259 9.17162L11.2939 11.2929M12.0007 6.34349L14.122 8.46481M5.07103 13.2725L13.2735 5.07005C14.0655 4.27802 14.4619 3.88201 14.9186 3.73363C15.3203 3.60311 15.7528 3.60311 16.1545 3.73363C16.6109 3.88192 17.0066 4.27757 17.7977 5.06871L18.9304 6.20143C19.7225 6.99345 20.1189 7.39041 20.2673 7.84706C20.3978 8.24875 20.3975 8.68058 20.267 9.08226C20.1187 9.53892 19.7227 9.93525 18.9307 10.7273L10.7283 18.9297C9.93623 19.7218 9.5399 20.1177 9.08324 20.2661C8.68155 20.3966 8.24973 20.3968 7.84804 20.2663C7.39138 20.1179 6.99443 19.7215 6.2024 18.9295L5.06968 17.7967C4.27855 17.0056 3.8829 16.6099 3.73461 16.1536C3.60409 15.7519 3.60409 15.3193 3.73461 14.9176C3.88298 14.4609 4.279 14.0645 5.07103 13.2725Z",
    stroke: "#282830",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRuler, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Ruler.9a874416.svg";
export { ForwardRef as ReactComponent };